/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Agent_Notice_Step_LimitInputs */



/**
* | output |
* | --- |
* | "The agent stopped after 20 steps. Ask it to continue if there is more to do." |
*
* @param {Assistant_Agent_Notice_Step_LimitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_notice_step_limit = /** @type {((inputs?: Assistant_Agent_Notice_Step_LimitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Notice_Step_LimitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'agent s'est arrêté après 20 étapes. Demandez-lui de continuer s'il reste plus à faire.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent hat nach 20 Schritten angehalten. Bitten Sie ihn, fortzufahren, falls noch weitere Schritte ausstehen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'agente si è fermato dopo 20 passaggi. Chiedigli di continuare se c'è altro da fare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Агент остановился после 20 шагов. Попросите его продолжить, если есть еще что сделать.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El agente se detuvo después de 20 pasos. Pídele que continúe si hay más pasos que realizar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理执行了 20 步后停止。如果还有任务需要执行，请请求其继续。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エージェントは20ステップで停止しました。まだやるべきことがある場合は、続行するように指示してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एजेंट 20 कदम चलने के बाद रुक गया। अगर और काम बाकी है तो उसे आगे बढ़ने के लिए कहें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O agente parou após 20 etapas. Peça para ele continuar se houver mais alguma coisa a fazer.")
	return /** @type {LocalizedString} */ ("The agent stopped after 20 steps. Ask it to continue if there is more to do.")
});